import { queryAllPages } from '../../apollo/query-all-pages';
import { gql } from "@apollo/client";
import { client } from "../../apollo/client";

const TRAILERS_REQUESTS = gql`
  query GetTrailers ($limit: Int!, $offset: Int!, $status: [Int!]) {
    trailers(limit: $limit, offset: $offset, status: $status) {
      data {
        codigo
        master
        status
        dataCadastro
        fabricacao
        anoFabricacao
        modelo
        anoModelo
        placa
        chassi
        volume
        capacidade
        tara
        pesoTotal
        unidade
      }
      totalRecords
    }
  }
`;

export const getAllTrailers = async (status) => {
  
    const response = await queryAllPages(client, {
      query: TRAILERS_REQUESTS,
      variables: {
        limit: 1000, 
        offset: 0,
        status
      }
    });
    const { data } = response.data.trailers;
    return data;
  
}
